export default __webpack_public_path__ + "static/icon-beb981077dbb01919a3e280ba75efa99.png";